import "./vyntezChat.css";

import React, { useState } from "react";
import { useVBTranslation } from "./language";

const VyntezChatWidget = () => {
  const { t } = useVBTranslation();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [thread, setThread] = useState([{ from: "bot", text: t("chatWelcome") }]);

  const sendMessage = (event) => {
    event.preventDefault();
    if (!message.trim()) {
      return;
    }

    setThread((prev) => [
      ...prev,
      { from: "user", text: message.trim() },
      { from: "bot", text: t("chatComingSoon") }
    ]);
    setMessage("");
  };

  return (
    <div className="vc-widget">
      {open && (
        <div className="vc-panel" role="dialog" aria-label={t("chatTitle")}>
          <div className="vc-panel-head">
            <div>
              <strong>{t("chatTitle")}</strong>
              <span>Online · replies coming soon</span>
            </div>
            <button type="button" className="vc-close-btn" onClick={() => setOpen(false)} aria-label="Close chat">
              ×
            </button>
          </div>

          <div className="vc-panel-body">
            {thread.map((entry, index) => (
              <div key={index} className={entry.from === "bot" ? "vc-bubble bot" : "vc-bubble user"}>
                {entry.text}
              </div>
            ))}
          </div>

          <form className="vc-panel-form" onSubmit={sendMessage}>
            <input
              type="text"
              value={message}
              onChange={(event) => setMessage(event.target.value)}
              placeholder={t("chatPlaceholder")}
            />
            <button type="submit">{t("chatSend")}</button>
          </form>
        </div>
      )}

      <button
        type="button"
        className="vc-launcher"
        onClick={() => setOpen((value) => !value)}
        aria-label={open ? "Close chat" : t("chatLauncher")}
      >
        <i className="fas fa-comments" aria-hidden="true"></i>
      </button>
    </div>
  );
};

export default VyntezChatWidget;
